import {
  archiveVariantApi,
  createVariantApi,
  deleteVariantBomApi,
  getVariantApi,
  getVariantBomApi,
  listVariantsByProductApi,
  putVariantBomApi,
  VariantsApiClientError,
} from './apiClient'
import type { ProductVariant, VariantCreateInput, VariantStatus } from './types'

export const variantService = {
  listByProduct(productId: string): Promise<ProductVariant[]> {
    return listVariantsByProductApi(productId)
  },
  getById(id: string): Promise<ProductVariant | null> {
    return getVariantApi(id)
  },
  create(productId: string, input: VariantCreateInput): Promise<ProductVariant> {
    return createVariantApi(productId, input)
  },
  archive(id: string, status: VariantStatus = 'inactive'): Promise<ProductVariant> {
    return archiveVariantApi(id, status)
  },
  getBom: getVariantBomApi,
  putBom: putVariantBomApi,
  deleteBom: deleteVariantBomApi,
}

export type {
  ProductVariant,
  VariantCreateInput,
  VariantStatus,
} from './types'
export { VARIANT_STATUS_LABEL } from './types'
export { VariantsApiClientError }
